<script lang="ts" setup>
import { type PropType, ref, computed } from 'vue';
import { getContainer } from '@dandelion/core';
import { CaseListServiceInterface } from '@dandelion/core';
import type TranslationService from '@dandelion/core/src/services/TranslationService';
import { NamedBindings } from '@dandelion/core';

const props = defineProps({
  context: {
    type: String as PropType<string>,
    required: true,
  },
  numberOfElementsPerPage: {
    type: Number as PropType<number>,
    required: true,
    default: 20,
  },
  deletedCaseList: {
    //TODO: try to remove
    type: Boolean as PropType<boolean>,
    required: true,
  },
});

const container = getContainer(props.context);
const caseListService = container.get(NamedBindings.CaseListService) as CaseListServiceInterface;
const translationService = container.get(NamedBindings.TranslationService) as TranslationService;
const endIndex = ref(props.numberOfElementsPerPage);

const numberOfCases = computed(() => {
  const isFiltered = caseListService.areFiltersActive.value;
  const isDeleted = props.deletedCaseList;
  
  if (isFiltered) {
    return isDeleted
      ? caseListService.filteredDeletedCases.length
      : caseListService.filteredCases.length;
  }
  
  return isDeleted
    ? caseListService.allDeletedCases.length
    : caseListService.allCases.length;
});

const emit = defineEmits<{
  (e: 'update', value: { startIndex: number; endIndex: number }): void;
}>();

function loadMoreCases() {
  endIndex.value += props.numberOfElementsPerPage;
  emit('update', { startIndex: 0, endIndex: endIndex.value });
}
</script>

<template>
  <button
    type="button"
    v-if="numberOfCases > numberOfElementsPerPage"
    @click="loadMoreCases"
    class="load-more-case-btn"
    v-html="translationService.t('Load More')"
  />
</template>

<style></style>
